import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import styles from '../../styles/common/DocumentsModal.module.css';
import modalStyles from '../../styles/common/Modal.module.css';

interface DocumentsModalProps {
    show: boolean;
    onHide: () => void;
}

const DocumentsModal: React.FC<DocumentsModalProps> = ({
    show,
    onHide,
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            scrollable={true}
            className={styles.faqModal}
            contentClassName={styles.scaleIn}
            animation={false}
        >
            <Modal.Header closeButton>
                <Modal.Title as="h3" className={modalStyles.modalTitle}>
                    Envío de Documentos
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="faq-content">
                    <h5>Envío Express de Documentos</h5>
                    <p>Contamos con un servicio especializado para el envío de sobres que contienen únicamente documentos. Es ideal para pasaportes, títulos universitarios, poderes legales y correspondencia importante.</p>

                    <h5>Tarifa Plana</h5>
                    <p>Los sobres de documentos tienen una tarifa plana preferencial, independiente del peso (hasta 0.5kg). Consulta nuestra calculadora de envíos seleccionando la categoría "Documentos".</p>

                    <h5>Tiempos de Entrega</h5>
                    <p>Por su naturaleza prioritaria, los documentos suelen entregarse en un lapso de <strong>5 a 7 días hábiles</strong> en las principales ciudades de Venezuela.</p>

                    <h5>Seguridad y Confidencialidad</h5>
                    <p>Entendemos la importancia de tu documentación. Todos los sobres viajan con un sello de seguridad y seguimiento estricto en cada punto de control.</p>

                    <h5>Restricciones</h5>
                    <p>Dentro del sobre de documentos <strong>no se pueden incluir</strong> objetos metálicos, tarjetas de crédito activas, dinero en efectivo o llaves. Cualquier elemento adicional convertirá el envío en un paquete de carga general.</p>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={onHide}
                    className={modalStyles.closeBtn}
                >
                    Entendido
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DocumentsModal;
